import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UfFlowTypeStepActivityDto} from "../../../model/dto/entity/uf-flow-type-step-activity.dto";
import {UfStepActivityTypeEnum} from "../../../model/dto/enum/uf-step-activity-type.enum";
import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";

@Injectable({
    providedIn: 'root'
})
export class UfFlowTypeStepActivityService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/uf/flowTypeStepActivities');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

    public getActivityComponent(
        crudService: MvsCrudService,
        coreService: MvsCoreService,
        activityType: UfFlowTypeStepActivityDto
    ): Type<any> {
        switch (activityType.activityType) {
            case UfStepActivityTypeEnum.form_input:
            case UfStepActivityTypeEnum.object_create:
            case UfStepActivityTypeEnum.object_update:
                return null;
            case UfStepActivityTypeEnum.widget_display:
            case UfStepActivityTypeEnum.object_review:
            case UfStepActivityTypeEnum.summary_display:
                return null;
            case UfStepActivityTypeEnum.object_select:
            case UfStepActivityTypeEnum.decision:
                return null;
            case UfStepActivityTypeEnum.validation_check:
            case UfStepActivityTypeEnum.pre_check:
            case UfStepActivityTypeEnum.confirm_execute:
                return null;
            default:
                return null;
        }
    }
}
